import styled from 'styled-components';
import { body2, colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { TagGroup } from 'ui/tags';
import { PlaceholderState } from 'ui/indexPages/PlaceholderState';
import { DashboardCard } from '../../Dashboard.styled';

export const DetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
`;

export const OverflowMenuItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
`;

export const ArchiveMenuItem = styled(OverflowMenuItem)`
  color: ${colors.textDestructive};

  &&& svg[data-temporary-fix] path {
    fill: ${colors.textDestructive};
    stroke: none;
  }
`;

export const StyledTagGroup = styled(TagGroup)`
  div:first-child {
    margin-left: 0;
  }
`;

export const TotalText = styled.div`
  ${body2}
  color: ${colors.secondaryText};
`;

export const StyledPlaceholderState = styled(PlaceholderState)`
  height: auto;
  min-height: ${pxToRem(264)};
`;

export const StyledDashboardCard = styled(DashboardCard)`
  && {
    padding: ${spacing.plusHalf};
    gap: ${spacing.base};
  }

  & > :last-child#top-campaign {
    margin-top: auto;
  }

  &:nth-last-child(1):nth-child(odd) {
    grid-column: 1 / -1;
}
`;
